import { Star, Info } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const REVIEWS = [
  {
    name: "Amara",
    city: "London",
    job: "Furniture Assembly",
    initials: "A",
    bg: "bg-teal",
    text: "Posted my job at lunch and had three offers by dinner. Picked someone with great reviews — the wardrobe looks brilliant.",
  },
  {
    name: "James",
    city: "Manchester",
    job: "TV Mounting",
    initials: "J",
    bg: "bg-navy",
    text: "Checked profiles, chose a verified tasker, and the TV was on the wall within the hour. Couldn't have been easier.",
  },
  {
    name: "Priya",
    city: "Bristol",
    job: "Garden Tidy-Up",
    initials: "P",
    bg: "bg-amber-500",
    text: "Loved being able to chat and agree a price before booking. Payment through the app made it feel completely safe.",
  },
];

export default function Reviews() {
  return (
    <section id="reviews" data-testid="reviews-section" className="py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="max-w-2xl">
          <Eyebrow>Reviews</Eyebrow>
          <h2 className="mt-4 font-display font-extrabold tracking-tight text-navy text-3xl sm:text-4xl lg:text-5xl">
            People getting things done.
          </h2>
          <p className="mt-4 inline-flex items-start gap-2 text-sm text-slate-500 bg-white border border-slate-200 rounded-xl px-4 py-3">
            <Info className="w-4 h-4 text-teal shrink-0 mt-0.5" />
            These are example reviews shown for illustration. Real customer reviews will appear here as our community grows.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5">
          {REVIEWS.map((r, i) => (
            <Reveal key={r.name} delay={i * 0.1}>
              <figure
                data-testid={`review-card-${r.name.toLowerCase()}`}
                className="h-full bg-white rounded-2xl border border-slate-200/80 p-7 shadow-sm hover:shadow-lg transition-shadow duration-300 flex flex-col"
              >
                <div className="flex items-center justify-between">
                  <div className="flex gap-0.5" aria-label="5 out of 5 stars">
                    {Array.from({ length: 5 }).map((_, s) => (
                      <Star key={s} className="w-4 h-4 fill-amber-400 text-amber-400" />
                    ))}
                  </div>
                  <span className="text-[10px] font-mono uppercase tracking-wider text-slate-400 border border-slate-200 rounded-full px-2.5 py-1">
                    Example
                  </span>
                </div>
                <blockquote className="mt-5 text-sm sm:text-base text-slate-700 leading-relaxed flex-1">
                  "{r.text}"
                </blockquote>
                <figcaption className="mt-6 pt-5 border-t border-slate-100 flex items-center gap-3">
                  <span
                    className={`w-10 h-10 rounded-full ${r.bg} grid place-items-center text-sm font-bold text-white`}
                  >
                    {r.initials}
                  </span>
                  <div>
                    <p className="text-sm font-bold text-navy">
                      {r.name} · {r.city}
                    </p>
                    <p className="text-xs text-teal font-medium">{r.job}</p>
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
